import { Children, Fragment } from "react";
import css from "./System.module.css";
import Request from "../Request/Request";

const System = ({ children, requests }) => {
  const nodes = Children.toArray(children);

  return <div className={css.main}>{children}</div>;
};

export default System;
